import TraitsListBlock from './TraitsListBlock'

export default TraitsListBlock
